import Model from '@ember-data/model';
import attr from 'ember-data/attr';
import { Header } from 'cio/utils/models/header';

export type RenderedProfileShortcut = {
  id: string;
  method: string;
  name: string;
  render_errors: string[];
  url: string;
  webhook: boolean;
};

export default class ProfileShortcut extends Model {
  @attr('string') name!: string;
  @attr('string') requestMethod!: string;
  @attr('string') url!: string;
  @attr('string') body!: string;
  @attr('boolean') webhook!: boolean;
  @attr({ defaultValue: () => [] }) headers!: Header[];
}

// DO NOT DELETE: this is how TypeScript knows how to look up your models.
declare module 'ember-data/types/registries/model' {
  export default interface ModelRegistry {
    'profile-shortcut': ProfileShortcut;
  }
}
